import type { ReactNode } from 'react';

interface ITourFigureFrameProps {
  width: number;
  height: number;
  /** The whole picture's accessible name — the figures carry labels, not prose. */
  alt: string;
  children: ReactNode;
}

/**
 * The frame every tour figure is drawn on: the labelled `<svg>`, the page wash
 * behind it and the card it sits on. Only the contents differ between figures,
 * so the chrome lives here rather than being copied into each one.
 */
export function TourFigureFrame({ width, height, alt, children }: ITourFigureFrameProps) {
  return (
    <svg viewBox={`0 0 ${width} ${height}`} fontFamily="var(--f-body)" role="img" aria-label={alt}>
      <rect width={width} height={height} fill="var(--g50)" />
      <rect x="10" y="10" width={width - 20} height={height - 20} rx="8" fill="var(--color-surface)" stroke="var(--g100)" />
      {children}
    </svg>
  );
}
